import { ActionIcon, rem, useComputedColorScheme, useMantineColorScheme } from '@mantine/core';
import { IconMoon, IconSun } from '@tabler/icons-react';

export function ColorSchemeToggle() {
  const { toggleColorScheme } = useMantineColorScheme();
  const resolvedColorScheme = useComputedColorScheme('dark');

  return (
    <ActionIcon
      variant="subtle"
      size="sm"
      onClick={toggleColorScheme}
      aria-label="Toggle color scheme"
    >
      {resolvedColorScheme === 'dark' ? <IconSun size={rem(16)} /> : <IconMoon size={rem(16)} />}
    </ActionIcon>
  );
}
